export const CRYPTO_DECIMAL = 8;
export const FIAT_DECIMAL = 2;